var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTagExtend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tag-01"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 24,
    height: 24,
    rx: 12,
    fill: "url(#paint0_linear_8128_10611)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 24,
    height: 24,
    rx: 12,
    stroke: "url(#paint1_linear_8128_10611)",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M11.5689 11.5687H11.5749M7.96448 9.8867L7.96448 12.5747C7.96448 12.8685 7.96448 13.0155 7.99767 13.1538C8.02711 13.2763 8.07565 13.3935 8.14152 13.501C8.21583 13.6223 8.31972 13.7262 8.52752 13.934L13.1343 18.5408C13.848 19.2545 14.2049 19.6113 14.6163 19.745C14.9783 19.8626 15.3682 19.8626 15.7302 19.745C16.1417 19.6113 16.4985 19.2545 17.2122 18.5408L18.5409 17.2121C19.2546 16.4984 19.6114 16.1415 19.7451 15.73C19.8627 15.3681 19.8627 14.9782 19.7451 14.6162C19.6114 14.2047 19.2546 13.8479 18.5409 13.1342L13.9341 8.5274C13.7263 8.3196 13.6224 8.2157 13.5012 8.1414C13.3937 8.07553 13.2765 8.02698 13.1539 7.99755C13.0156 7.96436 12.8687 7.96436 12.5748 7.96436L9.88682 7.96436C9.21394 7.96436 8.8775 7.96436 8.62049 8.09531C8.39442 8.2105 8.21062 8.3943 8.09543 8.62037C7.96448 8.87737 7.96448 9.21381 7.96448 9.8867ZM11.8692 11.5687C11.8692 11.7346 11.7348 11.8691 11.5689 11.8691C11.403 11.8691 11.2685 11.7346 11.2685 11.5687C11.2685 11.4029 11.403 11.2684 11.5689 11.2684C11.7348 11.2684 11.8692 11.4029 11.8692 11.5687Z",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8128_10611",
    x1: 3.60245,
    y1: 5.37499,
    x2: 32.6224,
    y2: 6.78717,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01AC47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#32BA7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8128_10611",
    x1: 3.60245,
    y1: 5.37499,
    x2: 32.6224,
    y2: 6.78717,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01AC47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#32BA7C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagExtend);
export default __webpack_public_path__ + "static/media/tag_extend.55f93a3316af140ab605db329bd5219a.svg";
export { ForwardRef as ReactComponent };